
import { Component, Vue, Watch } from 'vue-property-decorator';
import u from '@/utility/utility';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import cartServices from '@/services/cart-services';
import DetailProduct from './DetailProduct.vue';
import commonService from '@/services/common-services';
@Component({
  components: {
    Loading,
    DetailProduct
  },
})
export default class MainPayService extends Vue {
    private isLoading = false;
    private searchTerm = '';
    private searchSite = 'TAOBAO';
    private searchResult: any = null;
    private showDetailProduct = false;
    private detailProductUrl = '';
    private detailProductKey = 0;
    private products: any[] = [];
    private currentPage = 1;
    private pageSize = 20;
    private hasMoreProducts = true;
    private isLoadingMore = false;
    private isSearchingByImage = false;
    private isPasteFocused = false;
    private showImageSearchModal = false;
    private isDragOver = false;
    private searchCategories = [
        {
            id: 1,
            name: 'Thời trang nữ',
            image: '/img/thoi-trang-nu.png',
            keywords: ['Thời trang nữ', 'Quần áo cotton', 'Áo khoác nỉ', 'Chân váy', 'Váy liền', 'Áo sơ mi', 'Bộ đồ thời trang', 'Quần legging', 'Quần bò nữ', 'Quần áo nữ size lớn', 'Trang phục trung niên, người già', 'Váy cưới, lễ phục', 'Xu hướng phong cách']
        },
        {
            id: 2,
            name: 'Thời trang nam',
            image: '/img/thoi-trang-nam.png',
            keywords: ['Thời trang nam', 'Áo phông T-shirt', 'Áo sơ mi', 'Áo khoác jacket', 'Quần âu', 'Quần bò nam', 'Áo dệt kim', 'Áo hoodie', 'Áo len', 'Áo vest nam', 'Bộ đồ thoải mái', 'Trang phục bóng chày', 'Áo gió']
        },
        {
            id: 3,
            name: 'Thời trang trẻ em',
            image: '/img/thoi-trang-tre-em.png',
            keywords: ['Thời trang trẻ em', 'Áo khoác trẻ em', 'Trang phục trẻ em kiểu Hàn Quốc', 'Váy trẻ em', 'Đồ mẹ con']
        },
        {
            id: 4,
            name: 'Sản phẩm mẹ và bé',
            image: '/img/sp-me-va-be.png',
            keywords: ['Sản phẩm mẹ và bé', 'Quần áo trẻ sơ sinh', 'Đồ bầu', 'Bỉm, tã, giấy ướt', 'Giặt xả tắm gội ăn uống', 'Máy tiện/ngoài trời']
        },
        {
            id: 5,
            name: 'Giày dép',
            image: '/img/giay-dep.png',
            keywords: ['Giày dép', 'Giày nữ', 'Dép đi trong nhà', 'Giày vải', 'Giày nam', 'Giày trẻ em']
        },
        {
            id: 6,
            name: 'Đồ nội y',
            image: '/img/do-noi-y.png',
            keywords: ['Đồ nội y', 'Thị trường đồ lót', 'Đồ lót tạo dáng, đồ lót gợi cảm', 'Thị trường áo lót', 'Thị trường đồ ngủ', 'Thị trường tất']
        },
        {
            id: 7,
            name: 'Trang phục thể thao',
            image: '/img/trang-phuc-the-thao.png',
            keywords: ['Trang phục thể thao', 'Trang phục dã ngoại', 'Đồ bơi', 'Đồ bảo vệ balo']
        },
        {
            id: 8,
            name: 'Đồ chơi',
            image: '/img/do-choi.png',
            keywords: ['Đồ chơi', 'Đồ chơi nam châm', 'Khối rubik giải tỏa stress', 'Gậy gỗ giải tỏa stress', 'Đồ chơi tiệc tùng', 'Đồ chơi giải trí', 'Đồ chơi trí tuệ', 'Đồ ăn uống, bánh kẹo giả', 'Đồ chơi trẻ em', 'Đồ chơi bông', 'Đồ chơi xếp hình ghép khối', 'Đồ chơi tự lắp ráp DIY', 'Nhạc cụ trẻ em', 'Sách vải trẻ em', 'Mô hình xe', 'Máy bay điều khiển', 'Đồ chơi mô hình', 'Nhà bóng', 'Tìm kiếm nhiều']
        },
        {
            id: 9,
            name: 'Túi xách, vali',
            image: '/img/tui-xach-vali.png',
            keywords: ['Túi xách, vali', 'Ví mùa xuân hạ 2025', 'Mẫu túi, vali 2025', 'Túi ví nam', 'Túi, vali', 'Cặp sách khai giảng 2025']
        },
        {
            id: 10,
            name: 'Điện thoại',
            image: '/img/dien-thoai.png',
            keywords: ['Điện thoại', 'Phụ kiện điện thoại di động', 'Hàng chính hãng', 'Phụ kiện Apple']
        },
        {
            id: 11,
            name: 'Linh phụ kiện điện tử',
            image: '/img/do-dien-tu.png',
            keywords: ['Linh phụ kiện điện tử', 'Sản phẩm Internet và ngoại vi', 'Bán dẫn', 'Công cụ phát triển', 'Thiết bị thụ động', 'Mô đun điện tử']
        },
        {
            id: 12,
            name: 'Phụ kiện thể thao',
            image: '/img/phu-kien-the-thao.png',
            keywords: ['Phụ kiện thể thao', 'Đồ đi câu', 'Đồ cắm trại trên núi']
        },
        {
            id: 13,
            name: 'Điện gia dụng',
            image: '/img/dien-gia-dung.png',
            keywords: ['Điện gia dụng', 'Chăm sóc sức khỏe', 'Đồ bếp, đồ gia dụng', 'Đồ điện gia dụng/Thiết bị âm thanh video', 'Thiết bị sinh hoạt']
        },
        {
            id: 14,
            name: 'Thiết bị điện tử',
            image: '/img/thiet-bi-dien-tu.png',
            keywords: ['Thiết bị điện tử', 'Sản phẩm điện tử', 'Phụ kiện điện tử', 'Thiết bị thông minh', 'Thiết bị ngoại vi máy tính']
        },
        {
            id: 15,
            name: 'Trang điểm, mỹ phẩm',
            image: '/img/trang-diem.png',
            keywords: ['Trang điểm, mỹ phẩm', 'Nước hoa trang điểm', 'Chăm sóc da', 'Dụng cụ trang điểm', 'Sản phẩm chăm sóc móng']
        },
        {
            id: 16,
            name: 'Chăm sóc sắc đẹp',
            image: '/img/cs-sac-dep.png',
            keywords: ['Chăm sóc sắc đẹp', 'Chăm sóc cá nhân', 'Tẩy rửa gia đình', 'Khăn giấy, khăn ướt', 'Tẩy rửa quần áo']
        },
        {
            id: 17,
            name: 'Phụ kiện',
            image: '/img/phu-kien.png',
            keywords: ['Phụ kiện', 'Khăn quàng, khăn lụa', 'Mũ, găn tay', 'Đồng hồ, kính mắt', 'Thắt lưng, dây lưng']
        },
        {
            id: 18,
            name: 'Dụng cụ đo',
            image: '/img/dung-cu-do.png',
            keywords: ['Dụng cụ đo', 'Dụng cụ quang học', 'Dụng cụ đo nhiệt độ và độ ẩm', 'Dụng cụ đo lường']
        }
    ];

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private getSiteName(link) {
      if (!link) { return ''; }
      if (link.includes('1688')) { return '1688'; }
      if (link.includes('taobao')) { return 'Taobao'; }
      if (link.includes('tmall')) { return 'Tmall'; }
      return '';
    }

    private isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }

    private isValidURL(str) {
    try {
      return str.includes('1688.com') ||str.includes('taobao.com') || str.includes('tmall.com') || str.includes('e.tb.cn');
    } catch (_) {
      return false;
    }
  }

  private async created() {
    if (!this.rate) {
      await this.getRate();
    }
    // Thêm scroll listener
    window.addEventListener('scroll', this.handleScroll);
    // if (this.products.length === 0 && !this.showDetailProduct) {
    //   await this.loadProducts();
    // }
  }

  private beforeDestroy() {
    // Xóa scroll listener khi component bị destroy
    window.removeEventListener('scroll', this.handleScroll);
  }

  private handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    // Kiểm tra nếu user đã scroll gần tới cuối trang (còn 200px)
    if (scrollTop + windowHeight >= documentHeight - 200) {
      this.loadMoreProducts();
    }
  }

  private async getRate() {
    const result = await commonService.exchangeRate();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
    }
  }

  private getDetailProductUrl(itemUrl) {
    return `${this.extractItemId(itemUrl)}`;
  }
  
  private openDetailProductUrl(itemUrl) {
    this.searchTerm = itemUrl;
    this.searchProduct();
  }

  private extractItemId(url: string): string {
    if (!url) { return ''; }
    // Tìm url thực sự trong chuỗi nếu có dính text hoặc mã
    const urlMatch = url.match(/https?:\/\/[^\s]+/);
    if (urlMatch) {
      url = urlMatch[0];
    }
    try {
      const parsedUrl = new URL(url);
      const host = parsedUrl.hostname;
      if (host.includes('taobao.com') || host.includes('tmall.com')) {
        const id = parsedUrl.searchParams.get('id');
        return id ? `https://${host}/item.htm?id=${id}` : url;
      }
      return url;
    } catch (error) {
      return url;
    }
  }

  private async searchProduct() {
    // Kiểm tra xem searchTerm có phải là URL hay không
    if (this.isValidURL(this.searchTerm)) {
      // Nếu là URL, mở DetailProduct trong tab mới
      const detailUrl = this.getDetailProductUrl(this.searchTerm);
      const routeData = this.$router.resolve({ 
        name: 'detail-product-index', 
        query: { itemUrl: detailUrl } 
      });
      window.open(routeData.href, '_blank');
      return;
    }
    
    // Reset pagination khi tìm kiếm mới
    this.currentPage = 1;
    this.products = [];
    this.hasMoreProducts = true;
    
    await this.loadSearchResults();
  }

  private async loadSearchResults() {
    // Nếu không phải URL, thì tìm kiếm theo từ khóa bằng Elim API
    if (this.currentPage === 1) {
      this.isLoading = true;
    } else {
      this.isLoadingMore = true;
    }
    
    try {
      const result = await cartServices.searchProductsByKeyword(
        this.searchTerm, 
        this.searchSite.toLowerCase(),
        this.currentPage,
        this.pageSize
      );
      
      if (result && result.status === 200 && result.data) {
        // Xử lý response mới với cấu trúc { success, code, message, paginate, items }
        let products = [];
        
        if (result.data.success && result.data.items && Array.isArray(result.data.items)) {
          // Format mới: { success: true, items: [...] }
          products = result.data.items;
        } else if (result.data.data && result.data.data.items) {
          // Format cũ: { data: { data: { items: [...] } } }
          products = result.data.data.items;
        } else if (result.data.data && Array.isArray(result.data.data)) {
          // Format: { data: { data: [...] } }
          products = result.data.data;
        } else if (result.data.items) {
          // Format: { data: { items: [...] } }
          products = result.data.items;
        } else if (Array.isArray(result.data)) {
          // Format: { data: [...] }
          products = result.data;
        }
        
        if (this.currentPage === 1) {
          this.products = products;
        } else {
          this.products.push(...products);
        }
        
        // Kiểm tra có còn dữ liệu để tải không
        this.hasMoreProducts = products.length === this.pageSize;
        
        if (products.length === 0 && this.currentPage === 1) {
          // Không tìm thấy sản phẩm nào
        }
      } else {
        // Fallback về tìm kiếm cũ nếu Elim API không hoạt động
        const fallbackResult = await cartServices.searchProducts(this.searchSite, this.searchTerm, this.isMobile());
        if (fallbackResult && fallbackResult.status === 200 && fallbackResult.data.message === 'Success') {
          (this.$refs.tb_link as any).href = fallbackResult.data.data.url;
          (this.$refs.tb_link as any).click();
        }
      }
    } catch (error) {
      // Fallback về tìm kiếm cũ
      const fallbackResult = await cartServices.searchProducts(this.searchSite, this.searchTerm, this.isMobile());
      if (fallbackResult && fallbackResult.status === 200 && fallbackResult.data.message === 'Success') {
        (this.$refs.tb_link as any).href = fallbackResult.data.data.url;
        (this.$refs.tb_link as any).click();
      }
    }
    
    this.isLoading = false;
    this.isLoadingMore = false;
  }

  private async loadProducts() {
    this.isLoading = true;
    const result = await cartServices.listProducts();
    if (result && result.status === 200 && result.data.message === 'Success') {
      this.products.push(...result.data.data);
    }
    this.isLoading = false;
  }

  private searchByKeyword(keyword: string) {
    this.searchTerm = keyword;
    this.searchProduct();
  }

  private clearSearchResults() {
    this.products = [];
    this.searchTerm = '';
    this.currentPage = 1;
    this.hasMoreProducts = true;
  }

  private async loadMoreProducts() {
    if (!this.hasMoreProducts || this.isLoadingMore || !this.searchTerm) {
      return;
    }
    
    this.currentPage++;
    await this.loadSearchResults();
  }

  private openProductDetail(product: any) {
    // Sử dụng trường 'link' từ response mới, fallback về 'url' nếu cần
    const productUrl = product.link || product.url;
    if (productUrl) {
      // Mở DetailProduct trong tab mới
      const detailUrl = this.getDetailProductUrl(productUrl);
      const routeData = this.$router.resolve({ 
        name: 'detail-product-index', 
        query: { itemUrl: detailUrl } 
      });
      window.open(routeData.href, '_blank');
    }
  }

  private getPlatformName(platform: string): string {
    const platformMap = {
      'taobao': 'Taobao',
      'tmall': 'Tmall',
      '1688': '1688',
      'TAOBAO': 'Taobao',
      'TMALL': 'Tmall'
    };
    return platformMap[platform] || platform;
  }

  private formatPrice(price: any): string {
    if (!price) {
      return '';
    }
    
    // Nếu price là object có thuộc tính min/max
    if (typeof price === 'object' && price.min !== undefined) {
      if (price.min === price.max) {
        return `¥${price.min}`;
      } else {
        return `¥${price.min} - ¥${price.max}`;
      }
    }
    
    // Nếu price là string hoặc number
    return `¥${price}`;
  }

  private getProductImage(product: any): string {
    // Kiểm tra img_url từ response mới trước
    if (product.img_url) {
      return u.proxyImage(product.img_url);
    }
    
    // Kiểm tra product.image (format cũ)
    if (product.image) {
      return u.proxyImage(product.image);
    }
    
    // Nếu không có image, kiểm tra images array
    if (product.images && Array.isArray(product.images) && product.images.length > 0) {
      return u.proxyImage(product.images[0]);
    }
    
    // Fallback image nếu không có hình ảnh nào
    return '/img/no-image.png';
  }

  private triggerImageUpload() {
    (this.$refs.imageInput as HTMLInputElement).click();
  }

  private async handleImageUpload(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    await this.processImageSearch(file);
    
    // Reset input
    target.value = '';
  }

  private async processImageSearch(file: File) {
    // Kiểm tra loại file
    if (!file.type.startsWith('image/')) {
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: 'Vui lòng chọn file ảnh hợp lệ (JPG, PNG, GIF)',
      });
      return;
    }

    // Kiểm tra kích thước file (10MB)
    if (file.size > 10 * 1024 * 1024) {
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: 'File ảnh không được vượt quá 10MB',
      });
      return;
    }

    this.isSearchingByImage = true;

    try {
      // Sử dụng API upload và search trong một lần gọi
      const platform = this.searchSite.toLowerCase() === '1688' ? '1688' : 'taobao';
      const result = await cartServices.uploadImageAndSearch(file, platform, 1, 20);
      
      if (result && result.status === 200 && result.data) {
        this.handleSearchResults(result.data, 'tìm kiếm bằng ảnh');
        this.closeImageSearchModal(); // Đóng modal khi thành công
      } else {
        Vue.notify({
          group: 'foo',
          type: 'warning',
          title: 'Thông báo!',
          text: 'Không tìm thấy sản phẩm tương tự',
        });
      }
    } catch (error) {
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: 'Có lỗi xảy ra khi tìm kiếm bằng ảnh',
      });
    } finally {
      this.isSearchingByImage = false;
    }
  }

  private focusPasteArea() {
    this.isPasteFocused = true;
    
    // Focus vào paste area trong modal nếu modal đang mở
    if (this.showImageSearchModal && this.$refs.modalPasteArea) {
      (this.$refs.modalPasteArea as HTMLElement).focus();
    } else if (this.$refs.pasteArea) {
      (this.$refs.pasteArea as HTMLElement).focus();
    }
    
    // Auto unfocus after 10 seconds
    setTimeout(() => {
      this.isPasteFocused = false;
    }, 10000);
  }

  private closeImageSearchModal() {
    this.showImageSearchModal = false;
    this.isPasteFocused = false;
    this.isDragOver = false;
  }

  private handleDragOver(event: DragEvent) {
    this.isDragOver = true;
  }

  private handleDragLeave(event: DragEvent) {
    this.isDragOver = false;
  }

  private async handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    
    const items = event.clipboardData && event.clipboardData.items;
    if (!items) {
      return;
    }

    for (const item of items) {
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile();
        if (file) {
          await this.processImageSearch(file);
        }
        break;
      }
    }
    
    // Reset paste state
    this.isPasteFocused = false;
    if (this.$refs.modalPasteArea) {
      (this.$refs.modalPasteArea as HTMLElement).blur();
    }
  }

  private async handleDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
    
    const files = event.dataTransfer && event.dataTransfer.files;
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    if (file.type.startsWith('image/')) {
      await this.processImageSearch(file);
    } else {
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: 'Lỗi!',
        text: 'Vui lòng thả file ảnh hợp lệ (JPG, PNG, GIF)',
      });
    }
  }

  private async uploadImageForSearch(file: File): Promise<any> {
    try {
      const result = await cartServices.uploadImageForSearch(file);
      
      if (result && result.status === 200) {
        return result.data;
      } else {
        const message = (result && result.data && result.data.message) || 'Upload failed';
        throw new Error(message);
      }
    } catch (error) {
      throw error;
    }
  }

  private async searchProductsByImageUrl(imgUrl: string) {
    try {
      const platform = this.searchSite.toLowerCase() === '1688' ? '1688' : 'taobao';
      
      const result = await cartServices.searchProductsByImageUrl(imgUrl, platform, 1, 20);
      
      if (result && result.status === 200 && result.data) {
        this.handleSearchResults(result.data, 'tìm kiếm bằng ảnh');
      } else {
        Vue.notify({
          group: 'foo',
          type: 'warning',
          title: 'Thông báo!',
          text: 'Không tìm thấy sản phẩm tương tự',
        });
      }
    } catch (error) {
      throw error;
    }
  }

  private async searchProductsByImageId(imgId: string) {
    try {
      const platform = this.searchSite.toLowerCase() === '1688' ? '1688' : 'taobao';
      
      const result = await cartServices.searchProductsByImageId(imgId, platform, 1, 20);

      if (result && result.status === 200 && result.data) {
        this.handleSearchResults(result.data, 'tìm kiếm bằng ảnh');
      } else {
        Vue.notify({
          group: 'foo',
          type: 'warning',
          title: 'Thông báo!',
          text: 'Không tìm thấy sản phẩm tương tự',
        });
      }
    } catch (error) {
      throw error;
    }
  }

  private handleSearchResults(ret: any, searchType: string) {
    if (ret.data && ret.data.items.length > 0) {
      this.products = ret.data.items;
      this.searchTerm = searchType;
      this.currentPage = 1;
      this.hasMoreProducts = ret.data.items.length === 20; // Assume there might be more if we got a full page
      
      Vue.notify({
        group: 'foo',
        type: 'success',
        title: 'Thành công!',
        text: `Tìm thấy ${ret.data.items.length} sản phẩm tương tự`,
      });
    } else {
      Vue.notify({
        group: 'foo',
        type: 'info',
        title: 'Thông báo!',
        text: 'Không tìm thấy sản phẩm tương tự',
      });
    }
  }
}
